
export const features = [
    {
        rank: 1,
        title: "AI-Powered Mixing",
        subtext: "Intelligent track selection",
        cover: "https://picsum.photos/seed/ai/200/200"
    },
    {
        rank: 2,
        title: "Dual-Deck Playback",
        subtext: "Seamless beat-matched transitions",
        cover: "https://picsum.photos/seed/deck/200/200"
    },
    {
        rank: 3,
        title: "BPM Detection",
        subtext: "Perfect synchronization",
        cover: "https://picsum.photos/seed/bpm/200/200"
    },
    {
        rank: 4,
        title: "Thematic Coherence",
        subtext: "Matching energy and mood",
        cover: "https://picsum.photos/seed/vibe/200/200"
    },
    {
        rank: 5,
        title: "Open Codebase",
        subtext: "Run, modify, and extend",
        cover: "https://picsum.photos/seed/code/200/200"
    }
];
